export const formatStorageSpaceToMegabytes = (bytes) => {
  let megabyte = 1024 * 1024;
  let precision = 6;
  return (bytes / megabyte).toFixed(precision);
};
